export default "__VITE_ASSET__BL53WN4k__"